import classNames from 'classnames';
import React, { useCallback } from 'react';
import { RatingsSize, RatingsInput } from 'wix-ui-tpa/cssVars';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description';
import { FieldLabelWUT } from '../field-label';
import { FieldErrorWUT } from '../field-error';
import { getRatingInputFieldError } from './rating-input-field-utils';
import { classes } from './rating-input-field-wut.st.css';
import Fieldset from '../fieldset';
export const RatingInputFieldWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    required = false,
    description,
    value,
    onChange,
    onFocus,
    onBlur,
    error,
    disabled = false,
    customErrors,
    fieldType,
    validation,
    countryCode,
    additionalInfo,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    defaultValue
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const _error = getRatingInputFieldError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, fieldType, countryCode == null ? void 0 : countryCode.toLocaleLowerCase());
  const handleChange = useCallback(_value => {
    onChange(_value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(Fieldset, {
      id: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      onFocus: onFocus,
      onBlur: onBlur,
      required: required
    }, /*#__PURE__*/React.createElement(RatingsInput, {
      value: value || defaultValue || 0,
      onSelect: handleChange,
      size: RatingsSize.Large,
      disabled: disabled,
      className: classNames(classes.rating, {
        [FIELD_ERROR_CLASS]: hasError
      })
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), additionalInfo)
  });
};
//# sourceMappingURL=rating-input-field-wut.js.map